import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';

import { LoginComponent } from './login.component';
import { QRCodeModule } from 'angularx-qrcode';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    QRCodeModule,
    TranslateModule
  ],
  declarations: [
    LoginComponent 
  ]
})
export class LoginModule  {}


/*
Copyright Google LLC. All Rights Reserved. 
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/